import {global} from "../../appContext";
import organizationHtml from './organization.html?raw';

export let template = organizationHtml;

export class viewModel {
    private organizationName = global.login.selectedOrganization()?.organizationame ?? '';
    private organizationNameGenitive: string;
    private gdprStatement1: any
    private gdprStatement2: any

    constructor() {
        const name = this.organizationName;
        this.organizationNameGenitive = name.charAt(name.length).toLowerCase() == "s" ? name : name + "s"
        this.gdprStatement1 = {
            t: 'gdpr statement one',   
            p: {
                br: true, 
                r: {
                    organizationName: global.login.getHomeOrg()?.organizationame ?? '',
                    link: '<a href="mailto:salg@identum.no">salg@identum.no</a>'
                }
            }
        }
        this.gdprStatement2 = {
            t: 'gdpr statement two',
            p: {
                br: true,
                r: {
                    organizationName: global.login.getHomeOrg()?.organizationame ?? '',
                    link: '<a href="mailto:support@identum.no">support@identum.no</a>'
                }
            }
        }
    }
}
